/**
 * Mobile - Search molecule
 */

// Imports
import {
  init as initialInit,
  getSearchField,
  getSearchFieldPlaceholder,
  getSearchButton,
  goSearchpage,
} from '../../common/molecule/search';
import GlobalVars from '../../common/GlobalVars';
import KeyCodes from '../../common/KeyCodes';
import * as events from '../../common/Events';

/**
 * Reference to the search field element.
 * @type {Object}
 */
let searchField = {};

/**
 * Placeholder for the search field element.
 * @type {Object}
 */
let searchFieldPlaceholder = '';

/**
 * Reference to the search button element.
 * @type {Object}
 */
let searchButton = {};

function saveReferences() {
  // Save reference to the search field element
  searchField = getSearchField();

  // Save the placeholder of the earch field element
  searchFieldPlaceholder = getSearchFieldPlaceholder();

  // Save reference to the search button element
  searchButton = getSearchButton();
}

function searchPress(aoEvent, asDefaultValue, c, l) {
  if (aoEvent.keyCode === KeyCodes.enter) {
    aoEvent.preventDefault();
    aoEvent.stopPropagation();
    goSearchpage(asDefaultValue, c, l);
    return false;
  }
  return true;
}

function setEventHandlers() {
  if (!searchField.length) {
    return;
  }

  events.registerCallback({
    target: searchField,
    events: 'keydown',
    handler: function onSearchFieldKeydown(aoEvent) {
      return searchPress(aoEvent, searchFieldPlaceholder, GlobalVars.C, GlobalVars.L);
    },
  });

  events.registerCallback({
    target: searchButton,
    events: 'click',
    handler: function onSearchButtonClick() {
      goSearchpage(searchFieldPlaceholder, GlobalVars.C, GlobalVars.L);
    },
  });
}

function init() {
  $(() => {
    initialInit();

    // Save references to DOM elements
    saveReferences();

    // Set event handlers
    setEventHandlers();
  });
}

// Named exports - Functions
export {
  init,
  goSearchpage,
};



// WEBPACK FOOTER //
// ./js/mobile/molecule/search.js